import { ExcelExportButton } from '@/components/common/ExcelExportButton';
import { Banknote } from 'lucide-react';

export interface TabItem {
  label: string;
  icon: React.ReactNode;
  count?: number;
}

interface TabsNavProps {
  loanId: number;
  tabs: TabItem[];
  activeTab: number;
  onChange: (index: number) => void;
}

export function TabsNav({ loanId, tabs, activeTab, onChange }: TabsNavProps) {
  return (
    <div
      className="border-b border-gray-200 mb-6 flex justify-between items-center"
      data-test-id="tabs-container"
    >
      <nav className="-mb-px flex space-x-8 ">
        {tabs.map((tab, index) => (
          <button
            key={tab.label}
            onClick={() => onChange(index)}
            className={`
							py-2 px-1 border-b-2 font-medium text-sm flex items-center gap-2
							${
                activeTab === index
                  ? 'border-blue-500 text-blue-600'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              }
						`}
            data-test-id={`tab-${tab.label.toLowerCase().replace(' ', '-')}`}
          >
            {tab.icon}
            {tab.label}
            {tab.count && (
              <span className="ml-2 px-2 py-1 text-xs rounded-full bg-gray-100">
                {tab.count}
              </span>
            )}
          </button>
        ))}
      </nav>
      <ExcelExportButton
        exportType="fair-value-report"
        label="Export Fair Value Report"
        icon={<Banknote className="h-4 w-4" />}
        variant="default"
        loanId={loanId}
        className="relative top-[-10px]"
      />
    </div>
  );
}
